import { BrowserRouter, useLocation } from 'react-router-dom';
import { Header, Footer, CookieBanner, GoogleAnalytics } from './components';
import { ScrollToTop } from './components/ScrollToTop';
import { AppRoutes } from './routes';
import { WelcomeModal } from './components/WelcomeModal';
import { Toaster } from './components/ui/sonner';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  // Don't show header/footer for admin routes (including login)
  if (isAdminRoute) {
    return (
      <>
        <ScrollToTop excludePaths={['/admin']} />
        <AppRoutes />
      </>
    );
  }

  // Show header/footer for public routes
  return (
    <>
      <ScrollToTop excludePaths={['/admin']} />
      <WelcomeModal />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <AppRoutes />
        </main>
        <Footer />
      </div>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <GoogleAnalytics />
      <Toaster />
      <AppContent />
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
